module.exports = __webpack_public_path__ + "images/emails/signatures/izzy-17c7ae925261d9b511d5fe554badcc17.jpg";